<div id='orAdministrationTokens'>
  <div class='or-content'>
    @if (isBusy) {
      <mat-spinner></mat-spinner>
    }
    <div class='or-content-body'>
      <ul class='or-stacked-items or-tokens-list'>
        @for (token of tokens; track token; let i = $index) {
          <li
            class='or-stacked-item or-tokens-list-item'
            >
            <app-form-token-details [isNew]='false' [building]='building' [token]='token' [roles]='roles' [tenants]='tenants'
            (valueUpdated)='loadValues()' [index]='i'></app-form-token-details>
          </li>
        }
        <li class='or-stacked-item or-tokens-list-item'>
          <app-form-token-details [isNew]='true' [building]='building' [roles]='roles' [tenants]='tenants'
          (valueUpdated)='loadValues()' [index]='0'></app-form-token-details>
        </li>
      </ul>
      <br>
        <div>
          <app-checkbox [(ngModel)]='isShowDeactivatedTokens' ngDefaultControl
            (valueChange)='toggleShowDeactivatedTokens()'
            [dataCy]="'checkbox-show-deactivated-tokens'">
          </app-checkbox>
          <label class='margin-left-10'>Show deactivated tokens</label>
        </div>
        @if (deactivatedTokens?.length > 0) {
          <ul
            class='or-stacked-items or-tokens-list'
            >
            @for (deactivatedToken of deactivatedTokens; track deactivatedToken; let i = $index) {
              <li
                class='or-stacked-item or-tokens-list-item'
                >
                <app-form-token-details [isNew]='false' [building]='building' [token]='deactivatedToken' [roles]='roles' [tenants]='tenants'
                [isDeactivated]='true' [index]='i'></app-form-token-details>
              </li>
            }
          </ul>
        }
      </div>
    </div>
  </div>
